import React, { useContext, useState } from 'react';
import { AppStoreContext } from '../../context/appStoreContext';
import { ModalBody, Container, SignUpPromptModal } from './styles';
import { useHistory } from 'react-router-dom';

import Login from '../../containers/Authentication/Login';
import SignUp from '../../containers/Authentication/SignUp';
import { Container as SignUpContainer } from '../../containers/Authentication/styles';

const SignUpPrompt = props => {
  const { visible, onCancel, showPayBtn, handlePayDownload, payBtnLoading } = props;
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState('register');

  const {
    setLoginVisible,
    setOnboardingStatus
  } = useContext(AppStoreContext);

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  const redirectToLogin = () => {
    onCancel();
    setLoginVisible(true);
    setOnboardingStatus(false);
  }

  const onSignUpComplete = () => {
    history.push('/')
  }

  const onLoginComplete = () => {
    onCancel();
  }

  return (
    <Container onKeyDown={e => e.stopPropagation()}>
      <SignUpPromptModal
        title={null}
        centered
        maskClosable={true}
        visible={visible}
        width={showPayBtn ? "auto" : "625px"}
        onCancel={handleCancel}
        footer={null}
        className="signup-prompt-modal"
      >
        <ModalBody>
          <div className="signup-content">
            <SignUpContainer className="modal">
              {currentPage === 'login' && <Login setCurrentPage={setCurrentPage} onLoginComplete={onLoginComplete} />}
              {currentPage === 'register' && <SignUp setCurrentPage={setCurrentPage} onSignUpComplete={onSignUpComplete} showPayBtn={showPayBtn} handlePayDownload={handlePayDownload} payBtnLoading={payBtnLoading} />}
            </SignUpContainer>
          </div>
        </ModalBody>
      </SignUpPromptModal>
    </Container>
  );
};

export default SignUpPrompt;